import { uploadFile } from 'utils'
import { GetMapThumbnailUploadUrlQuery } from '~map-preview/types/__generated/gql/graphql'
import { graphierQL } from 'utils'

export const uploadMapThumbnail = async ({
  mapId,
  blobPath
}: {
  mapId: string
  blobPath: string
}) => {
  const fileBlob = await fetch(blobPath).then((r) => r.blob())

  const { uploadUrl, formFieldsJson } =
    await graphierQL<GetMapThumbnailUploadUrlQuery>({
      query: /* GraphQL */ `
        query GetMapThumbnailUploadUrl($mapId: ID!) {
          getMapThumbnailUploadUrl(mapId: $mapId) {
            uploadUrl
            formFieldsJson
          }
        }
      `,
      variables: { mapId },
      useToken: true
    }).then((res) => res.getMapThumbnailUploadUrl)

  await uploadFile({
    url: uploadUrl,
    formData: JSON.parse(formFieldsJson),
    file: new File([fileBlob], 'thumbnail.png', { type: 'image/png' })
  })
}
